/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Not_SessionsInputs */

const th_notifications_not_sessions = /** @type {(inputs: Notifications_Not_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`นี่คือเบราว์เซอร์ที่ลงทะเบียนรับการแจ้งเตือน ไม่ใช่ที่ที่บัญชีของคุณเข้าสู่ระบบ:`)
};

const en_notifications_not_sessions = /** @type {(inputs: Notifications_Not_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`These are the browsers registered to receive notifications, not where your account is signed in:`)
};

const ja_notifications_not_sessions = /** @type {(inputs: Notifications_Not_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`これは通知を受け取るために登録された端末で、アカウントがログイン中の端末ではありません:`)
};

const zh_notifications_not_sessions = /** @type {(inputs: Notifications_Not_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这些是已注册接收通知的浏览器——不是你的账户登录的位置：`)
};

const es_notifications_not_sessions = /** @type {(inputs: Notifications_Not_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estos son los navegadores registrados para recibir notificaciones, no dónde tienes la sesión iniciada:`)
};

const pt_notifications_not_sessions = /** @type {(inputs: Notifications_Not_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estes são os navegadores registrados para receber notificações, não onde sua conta está conectada:`)
};

const id_notifications_not_sessions = /** @type {(inputs: Notifications_Not_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ini peramban yang terdaftar untuk notifikasi — bukan tempat akun Anda sedang masuk:`)
};

const fr_notifications_not_sessions = /** @type {(inputs: Notifications_Not_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voici les navigateurs enregistrés pour recevoir les notifications, pas les endroits où votre compte est connecté :`)
};

const tl_notifications_not_sessions = /** @type {(inputs: Notifications_Not_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ito ang mga browser na nakarehistro para sa mga notipikasyon — hindi kung saan naka-sign in ang account mo:`)
};

const vi_notifications_not_sessions = /** @type {(inputs: Notifications_Not_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đây là các trình duyệt đã đăng ký nhận thông báo — không phải nơi tài khoản bạn đang đăng nhập:`)
};

const ko_notifications_not_sessions = /** @type {(inputs: Notifications_Not_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`알림 수신용으로 등록된 브라우저입니다. 계정이 로그인되어 있는 곳과는 다릅니다:`)
};

const de_notifications_not_sessions = /** @type {(inputs: Notifications_Not_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das sind die Browser, die für Benachrichtigungen registriert sind — nicht, wo dein Konto angemeldet ist:`)
};

const ru_notifications_not_sessions = /** @type {(inputs: Notifications_Not_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Это браузеры, зарегистрированные для уведомлений, — а не места, где выполнен вход в ваш аккаунт:`)
};

const tr_notifications_not_sessions = /** @type {(inputs: Notifications_Not_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bunlar bildirim için kayıtlı tarayıcılar — hesabınızın açık olduğu yerler değil:`)
};

const it_notifications_not_sessions = /** @type {(inputs: Notifications_Not_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questi sono i browser registrati per le notifiche, non i luoghi in cui il tuo account ha una sessione aperta:`)
};

const pl_notifications_not_sessions = /** @type {(inputs: Notifications_Not_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To przeglądarki zarejestrowane do powiadomień — a nie miejsca, w których twoje konto jest zalogowane:`)
};

const uk_notifications_not_sessions = /** @type {(inputs: Notifications_Not_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Це браузери, зареєстровані для сповіщень, — а не місця, де ваш обліковий запис має відкриту сесію:`)
};

const hi_notifications_not_sessions = /** @type {(inputs: Notifications_Not_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ये सूचनाओं के लिए दर्ज ब्राउज़र हैं — यह नहीं कि आपका खाता कहाँ साइन इन है:`)
};

const ar_notifications_not_sessions = /** @type {(inputs: Notifications_Not_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هذه المتصفحات مسجَّلة للإشعارات — لا الأماكن التي سجّل حسابك الدخول منها:`)
};

const ms_notifications_not_sessions = /** @type {(inputs: Notifications_Not_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ini pelayar yang didaftarkan untuk pemberitahuan — bukan tempat akaun anda log masuk:`)
};

const bn_notifications_not_sessions = /** @type {(inputs: Notifications_Not_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এগুলি বিজ্ঞপ্তির জন্য নিবন্ধিত ব্রাউজার — আপনার অ্যাকাউন্ট কোথায় সাইন ইন আছে তা নয়:`)
};

const zh_tw2_notifications_not_sessions = /** @type {(inputs: Notifications_Not_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這些是已註冊接收通知的瀏覽器——不是你的帳戶登入的位置：`)
};

const zh_hk2_notifications_not_sessions = /** @type {(inputs: Notifications_Not_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這些是已註冊接收通知的瀏覽器——不是你的帳戶登入的位置：`)
};

const ur_notifications_not_sessions = /** @type {(inputs: Notifications_Not_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`یہ اطلاعات کے لیے درج براؤزر ہیں — یہ نہیں کہ آپ کا اکاؤنٹ کہاں سائن اِن ہے:`)
};

const fa_notifications_not_sessions = /** @type {(inputs: Notifications_Not_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`این‌ها مرورگرهای ثبت‌شده برای اعلان‌اند — نه جاهایی که حساب‌تان در آن‌ها وارد شده است:`)
};

const sw_notifications_not_sessions = /** @type {(inputs: Notifications_Not_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hivi ni vivinjari vilivyosajiliwa kupokea arifa — si mahali akaunti yako ilipoingia:`)
};

const nl_notifications_not_sessions = /** @type {(inputs: Notifications_Not_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit zijn de browsers die voor meldingen zijn geregistreerd — niet waar je account is ingelogd:`)
};

/**
* | output |
* | --- |
* | "These are the browsers registered to receive notifications, not where your account is signed in:" |
*
* @param {Notifications_Not_SessionsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const notifications_not_sessions = /** @type {((inputs?: Notifications_Not_SessionsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Not_SessionsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_notifications_not_sessions(inputs)
	if (locale === "ja") return ja_notifications_not_sessions(inputs)
	if (locale === "zh") return zh_notifications_not_sessions(inputs)
	if (locale === "es") return es_notifications_not_sessions(inputs)
	if (locale === "pt") return pt_notifications_not_sessions(inputs)
	if (locale === "id") return id_notifications_not_sessions(inputs)
	if (locale === "fr") return fr_notifications_not_sessions(inputs)
	if (locale === "tl") return tl_notifications_not_sessions(inputs)
	if (locale === "vi") return vi_notifications_not_sessions(inputs)
	if (locale === "ko") return ko_notifications_not_sessions(inputs)
	if (locale === "de") return de_notifications_not_sessions(inputs)
	if (locale === "ru") return ru_notifications_not_sessions(inputs)
	if (locale === "tr") return tr_notifications_not_sessions(inputs)
	if (locale === "it") return it_notifications_not_sessions(inputs)
	if (locale === "pl") return pl_notifications_not_sessions(inputs)
	if (locale === "uk") return uk_notifications_not_sessions(inputs)
	if (locale === "hi") return hi_notifications_not_sessions(inputs)
	if (locale === "ar") return ar_notifications_not_sessions(inputs)
	if (locale === "ms") return ms_notifications_not_sessions(inputs)
	if (locale === "bn") return bn_notifications_not_sessions(inputs)
	if (locale === "zh-TW") return zh_tw2_notifications_not_sessions(inputs)
	if (locale === "zh-HK") return zh_hk2_notifications_not_sessions(inputs)
	if (locale === "ur") return ur_notifications_not_sessions(inputs)
	if (locale === "fa") return fa_notifications_not_sessions(inputs)
	if (locale === "sw") return sw_notifications_not_sessions(inputs)
	if (locale === "nl") return nl_notifications_not_sessions(inputs)
	return en_notifications_not_sessions(inputs)
});